import { memo } from "react";
import { Alert } from "@material-ui/core";
import PropTypes from "prop-types";

/**
 * Banner persistente que aparece mientras Formik tiene cambios sin guardar.
 * El texto se pasa via la prop `mensaje` para que cada vista use su propio copy.
 */
const BannerCambiosSinGuardar = memo(function BannerCambiosSinGuardar({
  visible,
  mensaje,
}) {
  if (!visible) return null;
  return (
    <Alert severity="info" sx={{ m: 2 }}>
      {mensaje}
    </Alert>
  );
});

BannerCambiosSinGuardar.propTypes = {
  visible: PropTypes.bool.isRequired,
  mensaje: PropTypes.node.isRequired,
};

export default BannerCambiosSinGuardar;
